import LoginPage from "./pages/LoginPage/LoginPage";
import { createBrowserRouter } from "react-router-dom";
import RouteNameConstants from "./constants/route-name.constants";
import ProjectPage from "./pages/ProjectPage/ProjectPage";
import PageNotFound from "./pages/NotFoundPages/NotFoundPage";
import ChooseProjectPage from "./pages/ProjectPage/pages/ChooseProjectPage/ChooseProjectPage";
import AuthRequired from "./utils/authRequired";
import FlowPage from "./pages/ProjectPage/pages/FlowPage/FlowPage";
import DeleteProjectPage from "./pages/DeleteProjectPage/DeleteProjectPage";
import React from "react";
import ProjectWrapper from "./utils/ProjectWrapper";

const routingConstants = createBrowserRouter([
    {
        path: '/',
        element: <AuthRequired component={ProjectPage}/>,
        errorElement: <PageNotFound/>,
        children: [
            {
                index: true,
                element: <ChooseProjectPage/>,
            },
            {
                path: `${RouteNameConstants.PROJECT_ID}/${RouteNameConstants.FLOW}`,
                element: <ProjectWrapper component={FlowPage}/>,
                children: [{
                        path: `${RouteNameConstants.TASK_ID}`,
                        element: <ProjectWrapper component={FlowPage}/>,
                    }]
            },
            {
                path: `${RouteNameConstants.CHOOSE_PROJECT}`,
                element: <ChooseProjectPage/>,
            }

        ]
    },
    {
        path: `/${RouteNameConstants.LOGIN}`,
        element: <LoginPage/>,
    },
    {
        path: `/${RouteNameConstants.DELETE_PROJECT}`,
        element: <AuthRequired component={DeleteProjectPage}/>,
    },
    {
        path: `/${RouteNameConstants.PROJECT_ID}`,
        element: <ProjectPage/>,
    },
]);


export default routingConstants;
